import React from 'react';
export function Footer() {
  return <footer className="bg-brand-deep px-4 py-12 text-center text-sm text-white/60" data-id="element-67" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-68" data-mp="3gg0za3iktxxn">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-69" data-mp="3gh3ng3oilm9v">
          🦉 HOCKEY READY
        </div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-70" data-mp="36p6dt1d5n2d9">
          Een complete, kant-en-klare hockeymethode voor trainers, clubs en
          scholen.
        </p>
        <nav aria-label="Juridisch" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-71" data-mp="3ud7ddkscv8gj">
          <a href="#voorwaarden" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-72" data-mp="3lf57aqtrlpme">
            Algemene Voorwaarden
          </a>
          <a href="#privacy" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-73" data-mp="29yno3sf6hjhp">
            Privacybeleid
          </a>
          <a href="#contact" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-74" data-mp="2evxbl2j0bl2w">
            Contact
          </a>
        </nav>
        <p data-id="element-75" data-mp="3gcjywzp6sgl4">© 2026 Hockey Ready — Alle rechten voorbehouden.</p>
      </div>
    </footer>;
}